import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserMemoryService {

  public token: string = '';
  public role: string = "";
  public isAdmin: boolean = false;
  public rank: number = 0;
  public isExternalUser = true;
  constructor() { }
}
